import React, { useEffect, useMemo, useState } from "react";
import notf from "../../assets/images/svg/notf.svg";
import { Box, Button, IconButton, Typography } from "@mui/material";
import dayjs from "dayjs";
import axios from "axios";
import { BASE_URL } from "../../constants";
import { io } from "socket.io-client";

import useNotifications from "../../hooks/notification/useNotifications";
export const socket = io(`${BASE_URL}admin`, {
  withCredentials: true,
  autoConnect: false,
  auth: {
    token: localStorage.getItem("token"),
  },
});

function Notifications() {
  const {
    handleChangeTab,
    handleClick,
    handleMarkall,
    notifications,
    openNoti,
    setOpenNoti,
    refe,
    tab,
    unreadcount,
    fetchNoti,
  } = useNotifications();
  return (
    <Box
      ref={refe}
      sx={{ position: "relative", display: "flex", justifyContent: "center" }}
    >
      <IconButton
        onClick={() => setOpenNoti((openNoti) => !openNoti)}
        sx={{
          background: "#673C8E59",
          // color: "#673C8E",
          mr: "30px",
          borderRadius: "15px",
          position: "relative",
        }}
      >
        <img style={{ width: "26px" }} src={notf} alt="Logo" />
        {unreadcount > 0 && (
          <div
            style={{
              padding: "2px",
              backgroundColor: "#683C8C",
              borderRadius: "9999px",
              color: "white",
              fontSize: "10px",
              position: "absolute",
              border: "3px solid white",
              top: "-7px",
              right: "-10px",
              width: "25px",
              height: "25px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {unreadcount}
          </div>
        )}
      </IconButton>
      {openNoti && (
        <Box
          sx={{
            width: "35vw",
            zIndex: 100,
            position: "fixed",
            top: "88px",
            right: "25px",
            padding: "16px",
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            animation: "fadeIn 0.1s ease-in-out",
            "@keyframes fadeIn": {
              from: { opacity: 0 },
              to: { opacity: 1 },
            },
          }}
        >
          <Typography
            sx={{ fontSize: "22px", fontWeight: 600, color: "black" }}
          >
            Notification
          </Typography>
          <Box
            display={"flex"}
            alignItems={"center"}
            gap="10px"
            bgcolor={"#683C8C0F"}
            px="8px"
            py="6px"
            mt="10px"
            borderRadius={"8px"}
          >
            <Button
              onClick={() => handleChangeTab("All")}
              sx={{
                fontSize: "14px",
                fontWeight: 600,
                backgroundColor: `${
                  tab === "All" ? "#673C8E" : "transparent"
                } !important`,
                color: `${tab === "All" ? "white" : "black"} !important`,
              }}
            >
              All
            </Button>
            <Button
              onClick={() => handleChangeTab("Read")}
              sx={{
                fontSize: "14px",
                fontWeight: 600,
                backgroundColor: `${
                  tab === "Read" ? "#673C8E" : "transparent"
                } !important`,
                color: `${tab === "Read" ? "white" : "black"} !important`,
              }}
            >
              Read
            </Button>
            <Button
              onClick={() => handleChangeTab("Unread")}
              sx={{
                fontSize: "14px",
                fontWeight: 600,
                backgroundColor: `${
                  tab === "Unread" ? "#673C8E" : "transparent"
                } !important`,
                color: `${tab === "Unread" ? "white" : "black"} !important`,
              }}
            >
              Unread
            </Button>
          </Box>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "10px",
            }}
          >
            {notifications.data.length > 0 &&
              tab !== "Read" &&
              unreadcount > 0 && (
                <Typography onClick={handleMarkall}>
                  Mark all as read
                </Typography>
              )}
          </div>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "5px",
              marginTop: "18px",
              maxHeight: "50vh",
              overflowY: "scroll",
            }}
          >
            {notifications.data.map((obj, i) => {
              return (
                <Box
                  onClick={() => handleClick(obj, i)}
                  key={i}
                  sx={{
                    padding: "10px",
                    width: "100%",
                    backgroundColor: !obj.isRead ? "#673C8E0F" : "",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      maxWidth: "75%",
                    }}
                  >
                    <div
                      style={{
                        width: "25px",
                        height: "25px",
                        borderRadius: "9999px",
                        border: "1px solid black",
                        backgroundColor: "#673C8E0F",
                        flexShrink: 0,
                      }}
                    ></div>
                    <Typography
                      sx={{
                        color: "#000000",
                        fontSize: "13px",
                        fontWeight: 700,
                        textWrap: "nowrap",
                        wordWrap: "break-word",
                        overflowX: "auto",
                        "&::-webkit-scrollbar": {
                          height: "4px",
                        },
                      }}
                    >
                      {obj.title}
                    </Typography>
                  </Box>
                  <Typography sx={{ fontSize: "11px", color: "black" }}>
                    {dayjs(obj.createdAt).format("h:mm A | DD MMM YYYY")}
                  </Typography>
                </Box>
              );
            })}
            {notifications.data.length < notifications.total && (
              <Box>
                <Typography
                  onClick={fetchNoti}
                  color="black"
                  textAlign={"center"}
                  fontSize={"14px"}
                  sx={{ textDecoration: "underline" }}
                >
                  Load{" "}
                  {notifications.total - notifications.data.length >= 20
                    ? "20"
                    : notifications.total - notifications.data.length}{" "}
                  More
                </Typography>
              </Box>
            )}
          </Box>
          {notifications.data.length < 1 && (
            <Typography sx={{ textAlign: "center", color: "black" }}>
              No Notifications
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
}

export default Notifications;
